import Form from "@/common/components/form/Form";
import { PinWrapper } from "./style";

const PinInput = () => {
  return (
    <PinWrapper>
      <Form
        processInputs={() => alert("pin entered")}
        formInputs={[
          {
            name: "pin",
            inputType: "password",
            fullWidth: true,
            rules: {
              minLength: {
                expectedValue: 4,
                errorMessage: "Enter 4 digit",
              },
            },
          },
        ]}
      />
    </PinWrapper>
  );
};

export default PinInput;
